function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 54,
  r: 47,
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 54,
  r: 53.5,
  stroke: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAA273",
  d: "M43.844 54.832c-2.259 0-4.107-.763-5.544-2.288-1.408-1.555-2.112-3.623-2.112-6.204 0-2.581.704-4.635 2.112-6.16 1.437-1.555 3.285-2.332 5.544-2.332 2.259 0 4.092.777 5.5 2.332 1.408 1.525 2.112 3.579 2.112 6.16s-.704 4.65-2.112 6.204c-1.408 1.525-3.241 2.288-5.5 2.288zM62.192 38.2h5.236L46.396 69H41.16l21.032-30.8zM43.844 51.224c.997 0 1.775-.41 2.332-1.232.587-.821.88-2.039.88-3.652s-.293-2.83-.88-3.652c-.557-.821-1.335-1.232-2.332-1.232-.968 0-1.745.425-2.332 1.276-.587.821-.88 2.024-.88 3.608s.293 2.801.88 3.652c.587.821 1.364 1.232 2.332 1.232zm20.9 18.128c-1.467 0-2.787-.337-3.96-1.012-1.144-.704-2.039-1.701-2.684-2.992-.645-1.29-.968-2.787-.968-4.488 0-1.701.323-3.197.968-4.488.645-1.29 1.54-2.273 2.684-2.948 1.173-.704 2.493-1.056 3.96-1.056 2.259 0 4.092.777 5.5 2.332 1.437 1.525 2.156 3.579 2.156 6.16s-.719 4.65-2.156 6.204c-1.408 1.525-3.241 2.288-5.5 2.288zm0-3.608c.997 0 1.775-.41 2.332-1.232.587-.85.88-2.068.88-3.652s-.293-2.787-.88-3.608c-.557-.85-1.335-1.276-2.332-1.276-.968 0-1.745.41-2.332 1.232-.587.821-.88 2.039-.88 3.652s.293 2.83.88 3.652c.587.821 1.364 1.232 2.332 1.232z"
});

var SvgPercent = function SvgPercent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    fill: "none",
    viewBox: "0 0 108 108",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPercent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/percent.dd8f009c.svg";
export { ForwardRef as ReactComponent };